/**
 * Labflow order as consumed by the UI. Transport-layer DTOs
 * (from `OrderController`) are mapped into this shape by
 * {@link mapOrderDto}.
 */
export interface Order {
  readonly id: string;
  readonly number: string;
  readonly customer: string;
  readonly productLine: string;
  readonly status: OrderStatus;
  readonly dueAt: string | null;
  readonly totalCents: number;
  readonly createdAt: string;
}

export const OrderStatus = {
  Draft: 'draft',
  Received: 'received',
  InProduction: 'in_production',
  Ready: 'ready',
  Shipped: 'shipped',
  Cancelled: 'cancelled',
} as const;
export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus];

export const ALL_ORDER_STATUSES: readonly OrderStatus[] = [
  OrderStatus.Draft,
  OrderStatus.Received,
  OrderStatus.InProduction,
  OrderStatus.Ready,
  OrderStatus.Shipped,
  OrderStatus.Cancelled,
];

export const ORDER_STATUS_LABELS: Readonly<Record<OrderStatus, string>> = {
  [OrderStatus.Draft]: 'Draft',
  [OrderStatus.Received]: 'Received',
  [OrderStatus.InProduction]: 'In production',
  [OrderStatus.Ready]: 'Ready',
  [OrderStatus.Shipped]: 'Shipped',
  [OrderStatus.Cancelled]: 'Cancelled',
};
